// ignore-string-externalization
import styled from 'styled-components';
import { Type, screenMdMin } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, withAnimationContext } from './Animations';
export var Headline = withAnimationContext(styled(Type.h1).attrs({
  variant: Type.heading1,
  weight: Type.bold
}).withConfig({
  displayName: "Headline",
  componentId: "i6m27p-0"
})(["", ";@media (min-width:", "){text-align:", ";}"], fadeInAnimation(DELAYS.SECOND), screenMdMin, function (_ref) {
  var centered = _ref.centered;
  return centered ? 'center' : 'left';
}));